export interface ProfileState {
    selectedTab: string;
}

export const initialState: ProfileState = {
    selectedTab:''
};